import { Typography } from "@mui/material";
import useTrees from "../../../../../Hooks/useTrees";
import { groupsTreeId } from "../../../../GroupsTraveler/Actions/loadGroupsTree";
import AutoHelp from "../../../../UI/Wrappers/AutoHelp";

const Group = ({ fontSize, group }) => {
  const trees = useTrees() ?? {};
  const groups = trees[groupsTreeId] ?? [];
  const selectedGroup = groups.find((g) => g.id === parseInt(group));
  const { name, parentId: parent } = selectedGroup;

  return (
    <AutoHelp {...{ fixedTooltip: name }}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {name}
      </Typography>
    </AutoHelp>
  );
};

export default Group;
